import React, { useState, useEffect } from 'react';
import { AiOutlineMinusCircle, AiOutlinePlusCircle } from 'react-icons/ai';

const CounterWidget = (props) => {
  const [value, setValue] = useState(props.value);

  const min = props.min || 0;
  const max = props.max || 5;

  const handleAdd = (e, value) => {
    e.preventDefault();
    e.stopPropagation();
    if (value >= max) {
      return value;
    }
    props.onSet(value + 1);
    return setValue(value + 1);
  };

  useEffect(() => {
    setValue(props.value);
  }, [props.value]);

  const handleDiv = (e, value) => {
    e.preventDefault();
    e.stopPropagation();
    if (value <= min) {
      return value;
    }
    props.onSet(value - 1);
    return setValue(value - 1);
  };

  return (
    <>
      <h3 className="tourists-counter__header">{props.header}</h3>
      <button
        className="tourists-counter__action tourists-counter__action_minus btn__minus"
        onClick={(e) => handleDiv(e, value)}
      >
        <AiOutlineMinusCircle />
      </button>
      <div className="tourists-counter__value">{value}</div>
      <button
        className="tourists-counter__action tourists-counter__action_plus btn__plus"
        onClick={(e) => handleAdd(e, value)}
      >
        <AiOutlinePlusCircle />
      </button>
    </>
  );
};

export default CounterWidget;
